import { Draggable } from "@hello-pangea/dnd";
import { Link2 } from "lucide-react";
import type { CSSProperties } from "react";

import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

import type { Task } from "../../types";
import { PriorityBadge } from "../PriorityBadge";
import { TaskMeta } from "./TaskMeta";

export interface TaskBoardCardProps {
  task: Task;
  index: number;
  cardName?: string;
  salesName?: string;
  onOpen: (task: Task) => void;
}

export const TaskBoardCard = ({
  task,
  index,
  cardName,
  salesName,
  onOpen,
}: TaskBoardCardProps) => (
  <Draggable draggableId={String(task.id)} index={index}>
    {(provided, snapshot) => (
      <div
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        style={provided.draggableProps.style as CSSProperties}
        onClick={() => onOpen(task)}
        aria-label={task.text}
        data-testid="task-card"
      >
        <Card
          className={cn(
            "gap-1.5 px-3 py-2.5",
            snapshot.isDragging
              ? "rotate-1 shadow-lg"
              : "shadow-xs hover:shadow-md",
          )}
        >
          <div className="flex items-start justify-between gap-2">
            <span className="text-sm font-medium leading-tight">
              {task.text}
            </span>
            {task.priority && task.priority !== "low" && (
              <PriorityBadge priority={task.priority} />
            )}
          </div>
          {cardName && (
            <span className="flex items-center gap-1 text-xs text-muted-foreground">
              <Link2 className="size-3" />
              {cardName}
            </span>
          )}
          <TaskMeta task={task} />
          {salesName && (
            <span className="text-xs text-muted-foreground">{salesName}</span>
          )}
        </Card>
      </div>
    )}
  </Draggable>
);
